module.exports = __webpack_public_path__ + "img/home_prj_qygl.ae98d801.jpg";